export default __webpack_public_path__ + "static/media/link2.e31ba41a.png";